import Dashboard from "../modules/user/dashboard/index.js";
import MyProfile from "../modules/user/settings/myprofile/index.js";
import Products from '../modules/user/products/index.js'
import Expenses from "../modules/user/expenses/index.js";
import MarketplaceCredentials from "../modules/user/settings/MarketplaceCredentials/index.js";
import Alerts from "../modules/user/alert";

export const Users = [
  {
    path: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "settings/products",
    element: <Products />
  },
  {
    path: "settings/expenses",
    element: <Expenses />
  },
  {
    path: "settings/marketplace-credentials",
    element: <MarketplaceCredentials />
  },
  {
    path: "settings/myprofile",
    element: <MyProfile/>
  },
  {
    path: "alerts",
    element: <Alerts/>
  },

  
];
